import { green, grey, indigo, red } from "@mui/material/colors";
import { brand, color as colorTokens, common } from "../design-system/tokens";
import { THEMES } from "../constants";

// LWI-1563 — Default and Dark come straight from the design system
// (src/design-system/theme.js). The other presets on the Profile page are
// IQ-only overrides layered on top of the light theme.

const defaultVariant = {
  name: THEMES.DEFAULT,
  mode: "light",
};

const darkVariant = {
  name: THEMES.DARK,
  mode: "dark",
};

const lightVariant = {
  name: THEMES.LIGHT,
  mode: "light",
  header: {
    color: grey[200],
    background: brand[800],
    search: {
      color: grey[100],
    },
    indicator: {
      background: red[700],
    },
  },
  sidebar: {
    color: grey[900],
    background: common.white,
    // LWI-1592 — red marker (6.1:1 on white); a white label would vanish.
    activeColor: grey[900],
    header: {
      color: common.white,
      background: brand[800],
      brand: {
        color: common.white,
      },
    },
    footer: {
      color: grey[800],
      background: colorTokens.light.surface.default,
    },
  },
};

const blueVariant = {
  name: THEMES.BLUE,
  mode: "light",
  sidebar: {
    color: common.white,
    background: brand[700],
    header: {
      color: common.white,
      background: brand[800],
      brand: {
        color: common.white,
      },
    },
    footer: {
      color: common.white,
      background: brand[800],
    },
    badge: {
      color: common.black,
      background: common.white,
    },
    // LWI-1592 — red clashes with a saturated sidebar; mark the active item in white.
    activeMarker: common.white,
  },
};

const greenVariant = {
  name: THEMES.GREEN,
  mode: "light",
  palette: {
    primary: {
      main: green[800],
      contrastText: common.white,
    },
    secondary: {
      main: green[500],
      contrastText: common.white,
    },
  },
  header: {
    indicator: {
      background: green[600],
    },
  },
  sidebar: {
    color: common.white,
    background: green[700],
    header: {
      color: common.white,
      background: green[800],
      brand: {
        color: common.white,
      },
    },
    footer: {
      color: common.white,
      background: green[800],
    },
    badge: {
      color: common.black,
      background: common.white,
    },
    // LWI-1592 — red clashes with a saturated sidebar; mark the active item in white.
    activeMarker: common.white,
  },
};

const indigoVariant = {
  name: THEMES.INDIGO,
  mode: "light",
  palette: {
    primary: {
      main: indigo[600],
      contrastText: common.white,
    },
    secondary: {
      main: indigo[400],
      contrastText: common.white,
    },
  },
  header: {
    indicator: {
      background: indigo[600],
    },
  },
  sidebar: {
    color: common.white,
    background: indigo[700],
    header: {
      color: common.white,
      background: indigo[800],
      brand: {
        color: common.white,
      },
    },
    footer: {
      color: common.white,
      background: indigo[800],
    },
    badge: {
      color: common.black,
      background: common.white,
    },
    // LWI-1592 — red clashes with a saturated sidebar; mark the active item in white.
    activeMarker: common.white,
  },
};

const variants = [
  defaultVariant,
  darkVariant,
  lightVariant,
  blueVariant,
  greenVariant,
  indigoVariant,
];

export default variants;
